import { LabStatusSchema } from "./lab"
import { OrderLabResultsUploadResponseSchema } from "./order"
import { z } from "zod"
import { IsoTimestampSchema } from "./string-validation"

export const PortalOrderLabPathSchema = z.object({
	orderId: z.uuid(),
	method: z.enum(["ship_kit", "upload_existing_results"]).nullable(),
	processing: z.boolean(),
	submissionNeedsReconciliation: z.boolean(),
	submissionIssue: z.object({
		requestId: z.uuid(),
		uploadDocumentId: z.uuid().nullable(),
		providerDocumentId: z.string().nullable(),
		label: z.string(),
		message: z.string(),
		nextAction: z.string(),
		canReconcile: z.boolean(),
	}).nullable(),
	kitStatus: LabStatusSchema.nullable(),
	labStatus: LabStatusSchema.nullable(),
	change: z.object({
		actorType: z.enum(["patient", "internal"]),
		actorUserId: z.uuid(),
		actorLabel: z.string(),
		occurredAt: IsoTimestampSchema,
		reason: z.string().nullable(),
	}).nullable(),
	documents: z.array(z.object({
		id: z.uuid(),
		source: z.enum(["patient", "staff"]),
		uploaderUserId: z.uuid(),
		uploaderLabel: z.string(),
		reason: z.string().nullable(),
	})),
	switchBlockReason: z.string().nullable(),
	uploadBlockReason: z.string().nullable(),
}).meta({ id: "PortalOrderLabPath" })
export type PortalOrderLabPath = z.infer<typeof PortalOrderLabPathSchema>

export const PortalOrderLabUploadResponseSchema = z.discriminatedUnion("status", [
	OrderLabResultsUploadResponseSchema.options[0].omit({ order: true }),
	OrderLabResultsUploadResponseSchema.options[1].omit({ order: true }).extend({ supportTicketId: z.uuid() }),
	OrderLabResultsUploadResponseSchema.options[2].omit({ order: true }).extend({ eligibilityResult: z.literal("ineligible"), reason: z.string() }),
]).meta({ id: "PortalOrderLabUploadResponse" })
